export enum MailchimpStatus {
  INFO_RECEIVED = 'info-received',
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
  PENDING = 'pending',
  ERROR = 'error',
}
